/* import __COLOCATED_TEMPLATE__ from './base.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { debounce } from '@ember/runloop';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { PHONE_DELIVERY_METHODS } from '../../enroll/base';
export const MANDATORY_TWO_FACTOR_PROMO_FLOWS = Object.freeze({
  SMS: 'SMS',
  AUTH_APP: 'AUTH_APP',
  AUTH_APP_ONLY: 'AUTH_APP_ONLY',
  // Dedicated flow where SMS is not provided as an option due to 'can_use_sms' field
  CODE: 'CODE',
  EXEMPTION: 'EXEMPTION'
});
let TwoFactorMandatoryPromoBaseComponent = (_dec = service('ember-multipassfe-client'), _dec2 = service('ember-multipass-logging'), _class = class TwoFactorMandatoryPromoBaseComponent extends Component {
  get tPrefix() {
    return this.args.tPrefix || '';
  }
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "multipassfeClient", _descriptor, this);
    _initializerDefineProperty(this, "logger", _descriptor2, this);
    _defineProperty(this, "flows", MANDATORY_TWO_FACTOR_PROMO_FLOWS);
    _defineProperty(this, "methods", Object.freeze({
      SMS: 'SMS',
      AUTH_APP: 'AUTH_APP'
    }));
    _defineProperty(this, "phoneDeliveryMethods", PHONE_DELIVERY_METHODS);
    _initializerDefineProperty(this, "error", _descriptor3, this);
    _initializerDefineProperty(this, "flow", _descriptor4, this);
    _initializerDefineProperty(this, "method", _descriptor5, this);
    _initializerDefineProperty(this, "phoneNumber", _descriptor6, this);
    _initializerDefineProperty(this, "phoneNumberDisplay", _descriptor7, this);
    _initializerDefineProperty(this, "mandatorySkipModalOpen", _descriptor8, this);
    _initializerDefineProperty(this, "mandatorySuccessModalOpen", _descriptor9, this);
    _initializerDefineProperty(this, "selectedPhoneDeliveryMethod", _descriptor10, this);
    this.logger.addComponentBreadcrumb('TwoFactorMandatoryPromoBaseComponent');
    this.checkAuthAppOnlyRestriction();
  }
  checkAuthAppOnlyRestriction() {
    if (!this.multipassfeClient.canUseSms) {
      this.navigateToAuthAppOnlyFlow();
    }
  }
  handleMandatorySkipModalOpen() {
    this.mandatorySkipModalOpen = true;
  }
  handleMandatorySkipModalClose() {
    this.mandatorySkipModalOpen = false;
  }
  setFlow(newFlow) {
    this.flow = newFlow;
  }
  setMethod(newMethod) {
    this.method = newMethod;
  }
  setPhoneNumber(newPhoneNumber) {
    this.phoneNumber = newPhoneNumber;
  }
  setPhoneNumberDisplay(newPhoneNumberDisplay) {
    this.phoneNumberDisplay = newPhoneNumberDisplay;
  }
  setSelectedPhoneDeliveryMethod(newPhoneDeliveryMethod) {
    this.selectedPhoneDeliveryMethod = newPhoneDeliveryMethod;
  }
  async resendSmsTwoFactorCodeDebounced() {
    debounce(this, this.resendSmsTwoFactorCode, 500, true);
  }
  async resendSmsTwoFactorCode() {
    try {
      if (this.selectedPhoneDeliveryMethod === this.phoneDeliveryMethods.VOICE) {
        return this.multipassfeClient.enrollTwoFactorVoice(this.phoneNumber);
      }
      return this.multipassfeClient.enrollTwoFactorSms(this.phoneNumber);
    } catch (e) {
      switch (e.message) {
        case 'TEMPORARY_LOCKOUT':
          break;
        default:
          this.logger.sentryError(e);
      }
    }
  }
  navigateToSmsFlow() {
    this.setMethod(this.methods.SMS);
    this.setFlow(this.flows.SMS);
  }
  navigateToAuthAppFlow() {
    this.setMethod(this.methods.AUTH_APP);
    this.setFlow(this.flows.AUTH_APP);
  }
  navigateToAuthAppOnlyFlow() {
    this.setMethod(this.methods.AUTH_APP);
    this.setFlow(this.flows.AUTH_APP_ONLY);
  }
  navigateToExemption() {
    this.handleMandatorySkipModalClose();
    this.setFlow(this.flows.EXEMPTION);
  }
  navigateToMethodFlow() {
    if (!this.multipassfeClient.canUseSms) {
      this.navigateToAuthAppOnlyFlow();
    } else if (this.method === this.methods.SMS) {
      this.navigateToSmsFlow();
    } else if (this.method === this.methods.AUTH_APP) {
      this.navigateToAuthAppFlow();
    }
  }
  handleMandatorySuccessModalOpen() {
    this.mandatorySuccessModalOpen = true;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "multipassfeClient", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "logger", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "error", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "flow", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.flows.SMS;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "method", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.methods.SMS;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "phoneNumber", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "phoneNumberDisplay", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "mandatorySkipModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "mandatorySuccessModalOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "selectedPhoneDeliveryMethod", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.phoneDeliveryMethods.SMS;
  }
}), _applyDecoratedDescriptor(_class.prototype, "handleMandatorySkipModalOpen", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleMandatorySkipModalOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleMandatorySkipModalClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleMandatorySkipModalClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setMethod", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setMethod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPhoneNumber", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPhoneNumber"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPhoneNumberDisplay", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPhoneNumberDisplay"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSelectedPhoneDeliveryMethod", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setSelectedPhoneDeliveryMethod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resendSmsTwoFactorCodeDebounced", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resendSmsTwoFactorCodeDebounced"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "resendSmsTwoFactorCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "resendSmsTwoFactorCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "navigateToSmsFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "navigateToSmsFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "navigateToAuthAppFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "navigateToAuthAppFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "navigateToAuthAppOnlyFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "navigateToAuthAppOnlyFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "navigateToExemption", [action], Object.getOwnPropertyDescriptor(_class.prototype, "navigateToExemption"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "navigateToMethodFlow", [action], Object.getOwnPropertyDescriptor(_class.prototype, "navigateToMethodFlow"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleMandatorySuccessModalOpen", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleMandatorySuccessModalOpen"), _class.prototype), _class);
export { TwoFactorMandatoryPromoBaseComponent as default };